const { default: WorkersTable } = require("./components/WorkersTable")

const WorkersComponent = () =>{
    return (
        
        <WorkersTable />
        
    )
}
export default WorkersComponent;